export default {"src":"/_next/static/media/keypadWithFinger_40.2614375c.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};